export const nullToEmptyString = (v: unknown) => (v === null ? '' : v);
export const nullToArray = (v: unknown) => (v === null ? [] : v);
